/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

// Standalone ticket purchase (no costume/box). Use this instead of
// holdTickets/holdStandaloneTickets: only this mutation enforces the
// per-person ticket limit across all of a person's tickets.
export const HOLD_TICKET_PURCHASE = gql`
  mutation HoldTicketPurchase($data: TicketPurchaseHoldInput!) {
    holdTicketPurchase(data: $data) {
      ticketOrderId
      feteName
      status
      ticketAmount
      convenienceFee
      total
      currency
      holdExpiresAt
      lines {
        tierName
        quantity
        unitPrice
        lineTotal
        lineFee
      }
    }
  }
`;
